import { getLocale } from "../runtime";

const da_trackordererrorloading = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kunne ikke indlæse sporingsinformation`
};

const en_trackordererrorloading = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Could not load tracking information`
};

const es_trackordererrorloading = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `No se pudo cargar la información de seguimiento`
};

const fi_trackordererrorloading = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Seurantatietojen lataaminen epäonnistui`
};

const nb_trackordererrorloading = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kunne ikke laste sporingsinformasjon`
};

const sv_trackordererrorloading = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kunde inte ladda spårningsinformation`
};

const trackordererrorloading = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_trackordererrorloading(inputs)
	if (locale === "en") return en_trackordererrorloading(inputs)
	if (locale === "es") return es_trackordererrorloading(inputs)
	if (locale === "fi") return fi_trackordererrorloading(inputs)
	if (locale === "nb") return nb_trackordererrorloading(inputs)
	if (locale === "sv") return sv_trackordererrorloading(inputs)
	return "trackOrderErrorLoading";
};

export { trackordererrorloading as "trackOrderErrorLoading" };